<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col
        lg="12"
        style="
          display: block;
          text-align: center;
          padding-bottom: 15px;
          font-size: 1.2em;
        "
        v-if="total > 0"
      >
        <span style="padding: 5px">Total Records:</span>
        <b>{{ total }}</b>
      </b-col>
      <b-col lg="12">
        <b-table
          v-if="!message"
          style="background: #3a4149"
          :items="data"
          :fields="fields"
          title="Search Result"
        >
          <template v-slot:cell(fnsid)="row">
            <a target="_blank"
              v-bind:href="
                envVar +
                  'tracker_private/includes/customerReportPublic.php?ftrack=' +
                  row.item.fnsid + '-' + row.item.fnsra
              "
              >{{ row.item.fnsid }}</a
            >
          </template>
          <template v-slot:cell(pod)="row">
            <!-- If Exchange -->
            <b-button
              v-if="row.item.pod"
              size="sm"
              @click="
                $router.push(
                  '/base/ProofOfDelivery/details/?ranum=' +
                    row.item.fnsra +
                    '&shipDate=' +
                    row.item.shipDate
                )
              "
              class="mr-1"
            >
              <i class="fa fa-eye" aria-hidden="true"></i>
            </b-button>

            <!-- If Exchange -->

            <b-button
              v-else-if="row.item.exchange"
              size="sm"
              @click="downloadExchange(row.item.exchange)"
              class="mr-1"
            >
              <i class="fa fa-download" aria-hidden="true"></i>
            </b-button>
            <span v-else>
              <p
                v-if="
                  row.item.pod !== true && row.item.delType === 'Onsite Scrap'
                "
              >
                {{ row.item.outTrack }}
              </p>
              <a
                v-if="row.item.pod !== true && row.item.delType === 'UPS'"
                :href="row.item.linkTrack"
                >{{ row.item.outTrack }}</a
              >
              <a
                v-if="row.item.pod !== true && row.item.delType === 'USPS'"
                :href="row.item.linkTrack"
                >{{ row.item.outTrack }}</a
              >
              <a
                v-if="row.item.pod !== true && row.item.delType === 'FedEx'"
                :href="row.item.linkTrack"
                >{{ row.item.outTrack }}</a
              >
            </span>
          </template>
        </b-table>
        <span v-else> {{ message }} </span>
        <div v-show="loading && !message" class="sk-double-bounce">
          <div class="sk-child sk-double-bounce1"></div>
          <div class="sk-child sk-double-bounce2"></div>
        </div>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import cTable from "../tables/Table.vue";

export default {
  name: "Search",
  components: { cTable },
  data: () => {
    return {
      envVar: process.env.VUE_APP_TRACKER_URL,
      loading: false,
      total: null,
      message: null,
      data: [],
      fields: [
        { key: "fnsid", label: "FNSID", sortable: true },
        { key: "fnsra", label: "RANUM", sortable: true },
        { key: "sernm", label: "Serial#" },
        { key: "pMake", label: "Manufacturer" },
        { key: "pMode", label: "Model" },
        {
          key: "shipDate",
          label: "Ship Date",
          formatter: (value, key, item) => {
            return item.shipDate
              ? item.shipDate.slice(5, 7) +
                  "/" +
                  item.shipDate.slice(8, 10) +
                  "/" +
                  item.shipDate.slice(0, 4)
              : null;
          }
        },
        { key: "locat", label: "Location" },
        { key: "price", label: "Price" },
        { key: "pod", label: "POD" }
      ]
    };
  },
  watch: {
    $route() {
      this.fetchData();
    }
  },
  methods: {
    fetchData() {
      this.data = [];
      this.message = null;
      this.loading = true;
      let params = {};
      params = {
        type: this.$route.query.type,
        value: this.$route.query.value
      };
      this.$http.get("api/tables/search.php", { params }).then(
        res => {
          if (res.data.message) {
            this.message = "Nothing found.";
            this.total = 0;
          } else {
            this.data = res.data.records;
            this.total =
              res.data.records.length > 0 ? res.data.records.length : 0;
            this.loading = false;
          }
        },
        err => {
          console.log(err);
        }
      );
    },
    downloadExchange(exchange) {
      let baseUrl = this.envVar + "tracker_private/";
      const { ranum } = exchange;

      if (ranum) {
        window.location.href = `${baseUrl}spreadsheets/exchangeReport.php?ranum=${ranum}`;
      }
    }
  },
  mounted() {
    this.fetchData();
  }
};
</script>
